import React, { useState } from 'react'
import * as pageUtils from './__index.utils'
import { DOCUMENT_ENVOYE_FORM } from './__index.utils'
import { docIcon, excelIcon, imgIcon, pdfIcon, wordIcon } from '@images/icons'
import { RepereIntegrationRepository } from '@services/repositories'
import { joinClasses } from '@utils/styles'

type DOCUMENT_EMIS = {
	CODE: string
	LIBELLE: string
}

type propsType = {
	documentsEmis: DOCUMENT_EMIS[] | []
	anneeDossier: string
	noDoss: number
	noDossier: string
	requeteGUID: string
}

const DocumentsEmisSection: React.FC<propsType> = ({
	documentsEmis,
	anneeDossier,
	noDoss,
	noDossier,
	requeteGUID
}) => {
	const RepereRepository = new RepereIntegrationRepository()

	const [downloadingIndex, setDownloadingIndex] = useState<string>('')

	const getRessourceId = (code) => {
		switch (code) {
			case 'ETAT_COMPTE':
				return 'etat-compte'
			case 'AVIS_RECEPTION':
				return 'avis-reception'
			case 'DOCUMENT_EMIS':
				return 'documents-emis'
			default:
				return 'documents-emis'
		}
	}

	const onClickDownload = async (item: DOCUMENT_EMIS) => {
		try {
			setDownloadingIndex(`${item.CODE}-${item.LIBELLE}`)

			const ressourceId = getRessourceId(item.CODE)
			const dossier = ressourceId == 'documents-emis' ? noDossier : noDoss
			const fileUrl = await RepereRepository.getDocumentEmis({
				ressourceId: ressourceId,
				filename: item.LIBELLE,
				anneeDossier,
				dossier: dossier,
				delivery: 'url',
				requeteGUID: requeteGUID // to be implemented
			})
			const response = await fetch(fileUrl)
			const blob = await response.blob()
			const url = window.URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', item.LIBELLE)
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch (error) {
			console.error('Erreur lors du téléchargement :', error)
		} finally {
			setDownloadingIndex('')
		}
	}

	const getAttachements = (files: DOCUMENT_EMIS[]) => {
		return files.map((item: DOCUMENT_EMIS, key) => (
			<div
				key={key}
				className={joinClasses([
					pageUtils.classes.attachmentItem,
					'documentsEmis'
				])}
			>
				<div className={pageUtils.classes.attachmentItemInfo}>
					<div className="flexCenter">
						<img src={docIcon} alt="icon" style={{ width: 26 }} />
					</div>
					<div
						className={pageUtils.classes.attachmentItemName}
						style={{ fontWeight: '500' }}
					>
						<span>{item.LIBELLE}</span>
					</div>
				</div>

				<div
					className={pageUtils.classes.attachmentItemDownload}
					onClick={() =>
						downloadingIndex !== '' ? undefined : onClickDownload(item)
					}
					style={{
						cursor:
							downloadingIndex == `${item.CODE}-${item.LIBELLE}`
								? 'wait'
								: 'pointer'
					}}
				>
					{downloadingIndex == `${item.CODE}-${item.LIBELLE}` ? (
						<span className="loader" />
					) : (
						'Télécharger'
					)}
				</div>
			</div>
		))
	}

	return (
		<div>
			{documentsEmis.length > 0 ? (
				getAttachements(documentsEmis)
			) : (
				<p
					className={pageUtils.classes.paragraph}
					style={{ marginBottom: '15px' }}
				>
					Aucun document n'a été ajouté.
				</p>
			)}
		</div>
	)
}

export default DocumentsEmisSection
